import { acceptHMRUpdate, defineStore } from 'pinia'

import type { IPackageFile } from '~/api/myedvenn/package_file';
import { AttendanceStatus } from '~/api/myedvenn/attendance';
import { CriteriaOperator } from '~/api/tolemac/pub/filter';

import { TrainingStatus, trainingStatus } from '~/util';

type TraineeState = {
    contactPackages: { contactPackageId: number; packageId: number; waitingAttendance: boolean; status: TrainingStatus }[];
    packageFiles: IPackageFile[]
}

export const useStoreTrainee = defineStore('trainee', {

    state: (): TraineeState => ({ contactPackages: [], packageFiles: [] }),

    getters: {
        contactPackagesAll: state => Object.values(state.contactPackages || {}),
        contactPackagesWaitingAttendance: state => Object.values(state.contactPackages || {}).filter(cp => cp.waitingAttendance),
        contactPackageGetById: state => (id: number) => state.contactPackages.find(c => c.contactPackageId === id),

        packageFileIdBycontactPackageId: state => (cpId: number) => state.packageFiles.find(pf=> pf.contactPackage.id === cpId )?.id
    },

    actions: {

        async refresh() {
            const [cp, pf, aW] = await Promise.all([
                this.$api.contactPackage.find({
                    relations: ['timespans']
                }),
                this.$api.packageFile.find({
                    relations: ['contactPackage'],
                    select: ['contactPackage.id']
                }),
                this.$api.attendance.find({
                    criterias: [
                        { field: 'status', value: `${AttendanceStatus.DRAFT}` },
                        { field: 'date', operator: CriteriaOperator.LESS, value: new Date().toISOString() }
                    ]
                })
            ])

            this.$state.packageFiles = pf.values
            this.$state.contactPackages = cp.values.map(_cp => ({
                contactPackageId: _cp.id,
                packageId: _cp.package.id,
                status: trainingStatus(_cp.timespans),
                waitingAttendance: aW.values.findIndex(a => a.contactPackage.id === _cp.id) !== -1
            }))
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useStoreTrainee, import.meta.hot))
}